import { createContext, useContext } from 'react'
import type { TeamMember } from '@/offline/roster'

/**
 * Who is working on this phone right now. Every command carries `actor.user_id` as actor_id —
 * when a supervisor unlocks the operator's phone with his own PIN, commands name him (F4.1).
 */
export type UnlockResult =
  | { ok: true; actor: TeamMember }
  | { ok: false; reason: 'wrong_pin'; triesLeft: number }
  | { ok: false; reason: 'locked_out'; retryInMs: number }
  | { ok: false; reason: 'no_pin' | 'unknown_user' }

export interface PhoneSessionValue {
  actor: TeamMember | null
  unlock: (userId: string, pin: string) => Promise<UnlockResult>
  lock: () => void
}

export const PhoneSessionContext = createContext<PhoneSessionValue | null>(null)

export function usePhoneSession(): PhoneSessionValue {
  const ctx = useContext(PhoneSessionContext)
  if (!ctx) throw new Error('usePhoneSession must be used inside <PhoneSessionProvider>')
  return ctx
}

/** The unlocked actor, for feature code that is only rendered behind RequireUnlocked. */
export function useActor(): TeamMember {
  const { actor } = usePhoneSession()
  if (!actor) throw new Error('useActor used outside an unlocked phone route')
  return actor
}
